import { Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useProto } from "./ProtoContext";
import { LEADERS, OVERVIEW, leaderName } from "./data";
import { leaderStats, leaderSummary, COMFORTABLE_LOAD } from "./directory";
import { Avatar, Pill, fullName } from "./ui";
import { cn } from "@/lib/utils";

export const actionBtn = "btn btn-outline btn-sm shrink-0";

export const AssignButton = ({ item, label = "Assign", exclude }) => {
  const { assigned, assign, rhythm } = useProto();
  if (assigned[item.id]) return <Pill tone="calm" className="shrink-0" data-testid={`assigned-${item.id}`}><Check size={14} /> {LEADERS[assigned[item.id]].first}</Pill>;
  return (
    <Popover>
      <PopoverTrigger asChild><button className={actionBtn} data-testid={`assign-${item.id}`}>{label}</button></PopoverTrigger>
      <PopoverContent align="end" className="w-[300px] max-h-96 overflow-y-auto rounded-2xl bg-surface border-line p-2" data-testid={`assign-popover-${item.id}`}>
        <p className="px-3 pt-2 pb-1 text-sm text-ink-faint">Who should care for {fullName(item).split(" ")[0]}?</p>
        {Object.values(LEADERS).filter((l) => l.id !== exclude).sort((a, b) => a.last.localeCompare(b.last)).map((l) => {
          const s = leaderStats(l.id, rhythm, assigned);
          const sum = leaderSummary(s);
          const team = OVERVIEW.teams.find((t) => t.lead === l.id);
          return (
            <button key={l.id} onClick={() => assign(item, l.id)} className="w-full flex items-start gap-3 px-3 py-2.5 rounded-xl hover:bg-sunk text-left" data-testid={`assign-${item.id}-to-${l.id}`}>
              <Avatar person={l} size={36} className="mt-0.5" />
              <span className="flex-1 min-w-0">
                <span className="block text-ink font-medium leading-tight">{leaderName(l.id)}</span>
                <span className="block text-sm text-ink-soft mt-0.5">
                  {s.people} people entrusted</span><span className="block mt-1"><Pill tone={sum.tone === "calm" ? "calm" : "today"} className="text-[13px] align-middle">{sum.tone === "calm" && <Check size={13} />}{sum.text}</Pill>
                </span>
                {(team || s.people > COMFORTABLE_LOAD) && (
                  <span className="block text-xs text-ink-faint mt-0.5">{[team && `Leads ${team.name}`, s.people > COMFORTABLE_LOAD && "Carrying more than usual"].filter(Boolean).join(" · ")}</span>
                )}
              </span>
            </button>
          );
        })}
      </PopoverContent>
    </Popover>
  );
};

export const RemindButton = ({ id, leader }) => {
  const { sent, remind } = useProto();
  if (sent[id]) return <Pill tone="calm" className="shrink-0"><Check size={14} /> Sent</Pill>;
  return <button className={actionBtn} onClick={() => remind(id, leader)} data-testid={`remind-${id}`}>Remind</button>;
};
